import { createQueryClient } from "@/utils/queryClient";

const queryClient = createQueryClient();

export default queryClient;
